
export enum PositionTokensEnum {
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
    SPACE_BETWEEN = "space-between"
}
